// src/lib/env.ts
// Handles environment variables for the frontend
// ================================
export const ENV = {
  SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL as string | undefined,
  SUPABASE_ANON: import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined,
  STRIPE_PUBLISHABLE: import.meta.env.VITE_STRIPE_PUBLISHABLE as string | undefined,
  EDGE_BASE: `${import.meta.env.VITE_SUPABASE_URL}/functions/v1`,
};

// Debug: only log loaded/missing status, never actual key values
if (import.meta.env.DEV) {
  console.groupCollapsed("🌍 Environment variables");
  console.log("SUPABASE_URL:", ENV.SUPABASE_URL ? "✅ Loaded" : "❌ Missing");
  console.log("SUPABASE_ANON_KEY:", ENV.SUPABASE_ANON ? "✅ Loaded" : "❌ Missing");
  console.log("STRIPE_PUBLISHABLE:", ENV.STRIPE_PUBLISHABLE ? "✅ Loaded" : "❌ Missing");
  console.groupEnd();
}

export function warnMissingClientEnv() {
  const missing: string[] = [];
  if (!ENV.SUPABASE_URL) missing.push("VITE_SUPABASE_URL");
  if (!ENV.SUPABASE_ANON) missing.push("VITE_SUPABASE_ANON_KEY");
  if (missing.length) {
    console.warn("[env] ⚠️ Missing client envs:", missing.join(", "));
  }
}
